import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const FavoriteIcon = ({ className = null }) => (
    <svg
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
        xmlns="http://www.w3.org/2000/svg"
        width="20.8"
        height="20.81"
        viewBox="0 0 20.8 20.81"
        fill="none"
    >
        <path
            d="M19.4,6.9c0-3-1.8-4.2-4.3-4.2a6.62,6.62,0,0,0-4.6,2.4A5.94,5.94,0,0,0,6.1,2.6c-2.5,0-4.7,1.27-4.7,4.2,0,8,9.1,12.1,9.1,12.1S19.4,14.79,19.4,6.9Z"
            strokeMiterlimit="10"
            strokeWidth="1.3"
            fill="currentColor"
            stroke="#EBE3C9"
        />
    </svg>
);

FavoriteIcon.propTypes = propTypes;

export default FavoriteIcon;
